import React from "react";
import { NavLink } from "react-router-dom";
import dummy from "../../../img/image.png";
/**
 * Renders staff image, name, and designation
 * @param {any} item staff object
 */
const PatientCard = ({ item }) => {
    if (item) {
        const { name, hcn, dob, id } = item;
        return (
            <NavLink
                className="profile-item-link"
                to={{
                    pathname: `/home/patient/profile/${id}`
                }}
            >
                <div className="flex">
                    <div className="flex-item margin-right-10">
                        <div
                            style={{
                                backgroundImage: `url(${item.profile_picture || dummy}`,
                                width: "50px",
                                height: "50px"
                            }}
                            className="img-container user-img-circle"
                        ></div>
                    </div>
                    <div className="flex-item p-t-5">
                        <strong className="text-pink">{name}</strong>
                        <br />
                        <span>
                            {hcn} |{" "}
                            <strong>
                                {Intl.DateTimeFormat("en-GB", {
                                    weekday: "short",
                                    month: "short",
                                    year: "numeric",
                                    day: "numeric"
                                }).format(new Date(dob))}
                            </strong>
                        </span>
                    </div>
                </div>
            </NavLink>
        );
    }
    return null;
};

export default PatientCard;
